export default __webpack_public_path__ + "static/slider-pp-mobile-e5c81fa638c63c1fa431edb441f7bc9d.jpg";